'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = unsubscriber;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  loading: false,
  success: false,
  error: null
};

function unsubscriber() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'UNSUBSCRIBE':
      return (0, _extends3.default)({}, state, { scope: action.scope, token: action.token, loading: true });
    case 'UNSUBSCRIBE_SUCCESS':
      return (0, _extends3.default)({}, state, {
        scope: action.scope,
        token: action.token,
        loading: false,
        success: true,
        result: action.result
      });
    case 'UNSUBSCRIBE_FAILURE':
      return (0, _extends3.default)({}, state, {
        scope: action.scope,
        token: action.token,
        loading: false,
        success: false,
        error: action.error
      });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/unsubscribe.js
// module id = 2539
// module chunks = 0